import { render, staticRenderFns } from "./Conduct.vue?vue&type=template&id=3bc24386&scoped=true&"
import script from "./Conduct.vue?vue&type=script&lang=js&"
export * from "./Conduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc24386",
  null
  
)

export default component.exports